module.exports = __webpack_public_path__ + "static/b1-rtj3-d28a637e05da09fcd96c3ad67c2af759.jpg";